var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"size":"sm","centered":_vm.t,"hide-footer":_vm.t,"hide-header":_vm.t,"ok-disabled":_vm.t,"cancel-disabled":_vm.t,"visible":_vm.showResponseModal},on:{"hidden":_vm.hideResponseModal}},[_vm._v(" Thank-you for submitting your feedback. We'll get right on it. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }